import { Route, Routes } from "react-router-dom";
import { publicRoutes } from "./allRoutes";

const RouteFile = () => {
  return (
    <>
      <Routes>
        {publicRoutes?.map((route, index) => (
          <Route key={index} path={route.path} element={route.component}>
            {route.children?.map((child, idx) => (
              <Route
                key={idx}
                index={child.index}
                path={child.path}
                element={child.element}
              />
            ))}
          </Route>
        ))}

        {/* {authProtectedRoutes?.map((route, idx) => (
          <Route key={idx} path={route.path} exact={route.exact}>
            <Route
              index
              element={
                  <DashBoard> {route?.component}</DashBoard>
              }
            />

            {route?.subRoute?.map((subRoute, subRouteIndex) => {
              return (
                <Route
                  key={subRouteIndex}
                  path={subRoute?.path}
                  // element={
                  //   <AuthLayout role={route?.role}>
                  //     {subRoute.component}{" "}
                  //   </AuthLayout>
                  // }
                  element={subRoute?.component}
                />
              );
            })}
          </Route>
        ))}
        {adminRoutes?.map((route, idx) => (
          <Route key={idx} path={route.path} exact={route.exact}>
            <Route
              index
              element={
                <AdminProtected>
                  <PermissionProtected menuNo={route.menuNo}>
                    <AdminDashboard> {route?.component}</AdminDashboard>
                  </PermissionProtected>
                </AdminProtected>
              }
            />
          </Route>
        ))} */}

        {/* <Route path="*" element={<PageNotFound />} /> */}
      </Routes>
    </>
  );
};

export default RouteFile;
